<template>
    <div>
        <web-menu />
        <information-overview-tab />
        <web-information />
        <!-- Use this component directly at startup if feedback has only point geometry or
             activate this component later when the button is clicked to make a feedback with line/polygon geometry -->
        <web-feedback
            v-if="
                getWebThemeHasFeedbackType &&
                (getWebThemeFeedbackHasPointGeoOnly ||
                    webFeedbackPanel.showDrawToolbar)
            "
        />
        <filter-selection />
        <legend-panel />
        <feedback-panel v-if="!getWebThemeHasFeedbackType" />
        <advanced-search-panel />
        <print-modal v-if="getMap" :map="getMap" />
        <status-messages />
        <alert-messages />
        <welcome-panel />
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import WebMenu from './menu/WebMenu.vue';
    import InformationOverviewTab from '../panels/information';
    import FilterSelection from './filters/Web.vue';
    import LegendPanel from './legend/Web.vue';
    import FeedbackPanel from './feedbacks';
    import AdvancedSearchPanel from '../panels/search';
    import StatusMessages from '../../BaseComponents/StatusMessages.vue';
    import AlertMessages from '../../BaseComponents/AlertMessages.vue';
    import PrintModal from '../../printing/PrintModal.vue';
    import WebFeedback from './webFeedback';
    import WebInformation from './webInformation';
    import WelcomePanel from './menu/WelcomeMessage.vue';
    import { INTERFACE_PANEL_TRIGGERS } from '../../../constants';

    export default {
        name: 'WebPanels',

        components: {
            'legend-panel': LegendPanel,
            'web-menu': WebMenu,
            'information-overview-tab': InformationOverviewTab,
            'filter-selection': FilterSelection,
            'status-messages': StatusMessages,
            'alert-messages': AlertMessages,
            'print-modal': PrintModal,
            'feedback-panel': FeedbackPanel,
            'advanced-search-panel': AdvancedSearchPanel,
            'web-feedback': WebFeedback,
            'web-information': WebInformation,
            'welcome-panel': WelcomePanel
        },

        props: {},

        data() {
            return {};
        },

        computed: {
            ...mapGetters([
                'getMainMap',
                'getWebThemeHasFeedbackType',
                'getWebThemeFeedbackHasPointGeoOnly'
            ]),
            ...mapState(['uiElements']),
            webFeedbackPanel: function () {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.WEB_FEEDBACK];
            },
            getMap() {
                return this.getMainMap?.map;
            }
        }
    };
</script>
